// extracted by mini-css-extract-plugin
export default {"content":"AssignMessageDialog_content__LeJvp","field":"AssignMessageDialog_field__LQFNP","label":"AssignMessageDialog_label__is3Zp","hint":"AssignMessageDialog_hint__JSCAz"};